export const SHOW_CONTACT_US_COMPONENT = "GLOBAL/SHOW-CONTACT-US-COMPONENT";
export const HIDE_CONTACT_US_COMPONENT = "GLOBAL/HIDE-CONTACT-US-COMPONENT";
